import React, { useState } from 'react'
import { IoClose } from 'react-icons/io5'
import Input from '../ui/forms/Input'
import ImageContainer from '../ui/comp/ImageContainer'
import { useQuery } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import Checkbox from '../ui/forms/Checkbox'
import { displayImage } from '../utils/config'

function UploadSelect({ onClose, sendFiles }) {

    const [selectedFiles, setselectedFiles] = useState([]);

    const { data } = useQuery({
        queryKey: ['medias'],
        queryFn: async () => {
            const res = await Axios.get('/media');
            return res.data;
        }
    })

    const handleFileSelect = (e) => {
        const file = e.target.value
        if (selectedFiles.includes(file)) {
            setselectedFiles(selectedFiles.filter(f => f !== file))
            return;
        }
        setselectedFiles([...selectedFiles, file])
    }

    const handleDone = () => {
        sendFiles(selectedFiles)
        onClose()
    }

    return (
        <div className='fixed w-full h-full top-0 left-0 z-[9999] flex justify-center items-center p-7'>
            <div className='bg-black/50 absolute w-full h-full' />
            <div className="max-w-4xl w-full bg-white relative z-[99] rounded-2xl overflow-hidden mx-auto">
                {/* Head */}
                <div className="px-5 py-3.5 bg-[#f2f2f2] flex items-center justify-between">
                    <p className='text-sm font-medium'>Select</p>
                    <button className='text-gray-500' onClick={() => onClose()}>
                        <IoClose size={17} />
                    </button>
                </div>

                {/* Contents */}

                <div className="w-full px-5 py-5">
                    <Input variant='complex' placeholder="Search files" />

                    <div className="mt-5">
                        <ImageContainer onFileUpload={() => { }} />
                    </div>

                    {/* Datas */}
                    {data?.length ? (
                        <div className='py-8 gap-1 w-full grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 max-h-[350px] overflow-y-auto'>
                            {data?.map((image, i) => (
                                <div key={i} className={`w-fit p-3 hover:bg-black/5 rounded-md ${selectedFiles.includes(image) ? 'bg-black/5' : null}`}>
                                    <div className="relative group p-1 border rounded-md h-auto max-w-24 overflow-hidden bg-white">

                                        <div className="p-1 top-1 left-1 absolute">
                                            <Checkbox
                                                checked={selectedFiles.includes(image)}
                                                value={image}
                                                onChange={handleFileSelect}
                                            />
                                        </div>

                                        <div className="">
                                            <img
                                                src={displayImage(image)}
                                                alt=""
                                                crossOrigin='anonymous'
                                                className=' object-contain size-24'
                                            />
                                        </div>
                                    </div>

                                    <p className="text-sm text-gray-500 truncate mt-2 max-w-24 cursor-pointer" title={image}>{image}</p>
                                </div>
                            ))}
                        </div>
                    ) :
                        <div className='py-8'> No medias found </div>
                    }
                </div>


                {/* Footer */}
                <div className="px-5 py-4 border-t">
                    <div className="flex items-center justify-between">
                        <div>
                            <button
                                onClick={() => setselectedFiles([])}
                                className={`text-blue-500 hover:underline text-xs font-medium ${selectedFiles?.length ? 'block' : 'hidden'}`}
                            >
                                Clear Selection
                            </button>
                        </div>



                        <div className='flex items-center gap-2'>
                            <button
                                onClick={() => onClose()}
                                className='text-xs px-3 py-2 bottom-1 shadow shadow-black/50 bg-white rounded-lg'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDone}
                                disabled={!selectedFiles?.length}
                                className={`text-xs px-3 py-2 bottom-1 shadow text-white rounded-lg
                                    ${selectedFiles.length ? 'bg-black' : 'bg-black/40'}
                                    `}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadSelect